/* eslint-env browser */
import * as React from 'react'

import { getCDNUrl } from '../../../../../../shared/services/media-helper'
import withTranslator from '../TranslatorProvider'

const PropTypes = require('prop-types')
const axios = require('axios')

const { CancelToken } = axios

const Pagination = require('../Pagination')
const EmptyData = require('../EmptyData')

class SearchBrands extends React.Component {
  constructor(props) {
    super()

    this.state = {
      brands: props.brands || [],
      query: props.query || '',
      page: props.page || 0,
      perPage: props.perPage || 50,
      totalCount: props.totalCount || 0,
      nbPages: Math.max(Math.ceil((props.totalCount || 0) / (props.perPage || 50)), 1),
      input: props.query || '',
      loading: false,
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.startQuery = this.startQuery.bind(this)
    this.setCurrentPage = this.setCurrentPage.bind(this)
    this.getUrl = this.getUrl.bind(this)
    this.getBrandsUrl = this.getBrandsUrl.bind(this)
    this.onInputSubmit = this.onInputSubmit.bind(this)

    this.debounceStartQuery = this.startQuery

    this.searchCancelSource = CancelToken.source()
  }

  componentWillMount() {
    const { brands, query, page, totalCount, perPage } = this.props

    this.setState({
      brands,
      query,
      page,
      perPage,
      totalCount,
      input: query,
      nbPages: Math.max(Math.ceil(totalCount / perPage), 1),
    })
  }

  onInputChange(e) {
    if (e) {
      e.preventDefault()
    }
    const input = e.target.value || ''
    this.setState(
      {
        loading: true,
        input,
        page: 0,
      },
      this.debounceStartQuery
    )
  }

  onInputSubmit(e) {
    if (e) {
      e.preventDefault()
    }
    const input = e.target.q.value || ''
    this.setState(
      {
        loading: true,
        input,
        page: 0,
      },
      this.debounceStartQuery
    )
  }

  setCurrentPage(page) {
    const { nbPages } = this.state
    if (page >= nbPages || page < 0) {
      return
    }
    this.setState(
      {
        loading: true,
        page,
      },
      this.debounceStartQuery
    )
  }

  getUrl(page) {
    const { query } = this.state
    const q = encodeURIComponent(query)
    return `/gear/brands/?q=${q}&page=${page}`
  }

  getBrandsUrl(seoName) {
    const { host } = this.props
    return `${host}/gear/brands/${seoName}`
  }

  startQuery() {
    const { input, page, perPage } = this.state

    this.searchCancelSource.cancel()
    this.searchCancelSource = CancelToken.source()

    axios
      .get(`/api/search/brands/${input}`, {
        cancelToken: this.searchCancelSource.token,
        params: {
          _perPage: perPage,
          _page: page,
        },
      })
      .then(res => {
        const totalCount = parseInt(res.headers['x-total-count'], 10) || 0
        this.setState(
          {
            brands: res.data,
            query: input,
            totalCount,
            nbPages: Math.max(Math.ceil(totalCount / perPage), 1),
            loading: false,
          },
          () => {
            this.changeUrlByState()
            this.changeTitle()
          }
        )
      })
      .catch(err => {
        if (!axios.isCancel(err)) {
          throw err
        }
      })
  }

  changeUrlByState() {
    const { query, page } = this.state
    if (window.history.replaceState) {
      const newurl = `${window.location.protocol}//${window.location.host}${
        window.location.pathname
      }?q=${query}&page=${page + 1}`
      window.history.replaceState({ path: newurl }, '', newurl)
    }
  }

  changeTitle() {
    const { translate } = this.props
    const { query, page, nbPages } = this.state
    const splitTitle = document.title.split('|')
    document.title = `${splitTitle[0]} ${
      query.length > 0 ? `| ${translate('search.searchBrands.research')} "${query}"` : ''
    } | page ${page + 1}/${nbPages} | ${splitTitle[3]}`
  }

  render() {
    let mainContentComponent = (
      <div className="has-margin-medium">
        <div className="loader is-size-1 is-primary is-large is-self-centered" />
      </div>
    )

    let { loading } = this.state
    loading = false // disable loading state to get faster results !
    const { totalCount, brands, page, perPage, input } = this.state
    const { locale, translate, host } = this.props

    if (!loading) {
      if (totalCount === 0) {
        mainContentComponent = (
          <div className="has-margin-top-medium">
            <EmptyData
              emptyableId={input && input.length > 0 ? input : 'brands'}
              title={translate('search.searchBrands.noresults')}
            />
          </div>
        )
      } else {
        mainContentComponent = [
          <div className="columns is-mobile is-centered is-multiline has-margin-vertical-small" key="brands-list">
            {brands.map(brand => (
              <div
                key={brand.id}
                className="column is-6-mobile is-4-tablet has-margin-vertical-zero animated fadeIn faster"
                itemScope
                itemType="http://schema.org/Brand"
              >
                <a itemProp="url" href={this.getBrandsUrl(brand.seoName)}>
                  <div className="media is-full-height">
                    <div className="media-left has-margin-right-xxsmall">
                      <figure className="image" style={{ height: 24, width: 48 }}>
                        {((brand.medias[0] || {}).url_300 ||
                          (brand.medias[0] || {}).url_600 ||
                          (brand.medias[0] || {}).url) && (
                          <img
                            itemProp="logo"
                            alt={brand.name}
                            src={getCDNUrl(brand.medias[0], 'small', { name: brand.seoName, type: 'brandLogo' })}
                            style={{ height: '100%' }}
                            className="has-object-fit-contain"
                          />
                        )}
                      </figure>
                    </div>
                    <div className="media-content is-self-centered">
                      <div itemProp="name" className="title is-6 has-text-link">
                        {brand.name}
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>,
          <Pagination
            key="pagination"
            page={page}
            perPage={perPage}
            totalCount={totalCount}
            getUrl={this.getUrl}
            onSelectPage={this.setCurrentPage}
            locale={locale}
          />,
        ]
      }
    }

    return (
      <section className="section has-text-centered" style={{ minHeight: '50vh' }}>
        <form
          itemProp="potentialAction"
          itemScope
          itemType="http://schema.org/SearchAction"
          action={`${host}/gear/brands`}
          method="GET"
          onSubmit={this.onInputSubmit}
        >
          <div className="field has-addons" style={{ justifyContent: 'center' }}>
            <div className="control">
              <meta itemProp="target" content="/gear/brands?q={q}" />
              <input
                itemProp="query-input"
                id="searchBrands"
                name="q"
                className="input is-medium is-primary"
                type="text"
                placeholder={translate('search.searchBrands.research')}
                onChange={e => this.onInputChange(e)}
                value={input}
              />
            </div>
            <div className="control">
              <input
                type="submit"
                className="button is-primary is-medium"
                value={translate('search.searchBrands.research')}
              />
            </div>
          </div>
        </form>
        {mainContentComponent}
      </section>
    )
  }
}

SearchBrands.propTypes = {
  brands: PropTypes.array,
  page: PropTypes.number,
  perPage: PropTypes.number,
  totalCount: PropTypes.number.isRequired,
  query: PropTypes.string,
  locale: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  host: PropTypes.string.isRequired,
}

SearchBrands.defaultProps = {
  brands: [],
  page: 0,
  perPage: 50,
  query: '',
}

module.exports = withTranslator(SearchBrands)
